import { trackFormWizardEvent } from '../../tracking/track_form_wizard_event';

/**
 * Wraps a form submission 
 * @param {Promise} submitPromise - The promise from the form submission
 * @param {Element} step - The step element that represents the form submit action
 * @param {String} action - The event action name
 * @returns 
 */
export default async function trackFormWizardSubmissionEvents(submitPromise, step, action) {
  try {
    await submitPromise;
    trackFormWizardEvent(step, { category: 'form_wizard_submit', action });
  } catch(error) {
    trackFormWizardEvent(step, {
      category: 'form_wizard_submit_failure',
      action: `${action}_failure`
    });
    error.originalMessage = error.message;
    error.message = 'Server error, could not submit form.';
    throw error;
  }
}
